module.exports = {"340826100":"孚玉镇","340826101":"复兴镇","340826102":"汇口镇","340826103":"许岭镇","340826104":"下仓镇","340826105":"二郎镇","340826106":"破凉镇","340826107":"凉亭镇","340826108":"长铺镇","340826200":"高岭乡","340826201":"程岭乡","340826202":"九姑乡","340826203":"千岭乡","340826204":"洲头乡","340826205":"佐坝乡","340826206":"北浴乡","340826207":"陈汉乡","340826208":"隘口乡","340826209":"柳坪乡","340826210":"趾凤乡","340826211":"河塌乡","340826212":"五里乡","340826400":"九成监狱管理分局","340826401":"华阳河农场总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340826.json
// module id = 1010
// module chunks = 0